export default __webpack_public_path__ + "static/media/future25.1a508bb2.jpg";